'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import clsx from 'clsx';
import { useAtomValue } from 'jotai';
import { useIsClient } from 'usehooks-ts';
import { useActivateVoucher } from '@/hooks/useCartHooks';
import { useIsPromotionBannerDisabled } from '@/hooks/useIsPromotionBannerDisabled';
import { useTrackPromo } from '@/hooks/useTrackPromo';
import { isPromoExpiredAtom, promoConfigAtom } from '@/atoms/promoAtom';
import { getPromoExpiryDate, setPromoPopupClosed } from '@/utility/promos';
import PromoPopup from '../PromoPopup/PromoPopup';
import { PromoAnnouncementBar } from './PromoAnnouncementBar';
export default function NestedPromoBanner() {
  const $ = _c(20);
  const [showPopup, setShowPopup] = useState(false);
  const promoSlot = useAtomValue(promoConfigAtom);
  const isExpired = useAtomValue(isPromoExpiredAtom);
  const {
    applyVoucher
  } = useActivateVoucher();
  const trackPopup = useTrackPromo();
  const isClient = useIsClient();
  const isPromotionBannerDisabled = useIsPromotionBannerDisabled();
  if (!promoSlot || !isClient || isExpired || isPromotionBannerDisabled) {
    return null;
  }
  const promoToolModuleData = promoSlot.content["promo-tool"];
  const voucherCode = promoToolModuleData.campaignDetails.code;
  let t0;
  if ($[0] !== voucherCode) {
    t0 = () => {
      setShowPopup(false);
      if (voucherCode) {
        setPromoPopupClosed(voucherCode, getPromoExpiryDate());
      }
    };
    $[0] = voucherCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClose = t0;
  let t1;
  if ($[2] !== trackPopup) {
    t1 = () => {
      setShowPopup(true);
      trackPopup("header banner");
    };
    $[2] = trackPopup;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleUserOpen = t1;
  const t2 = promoSlot.content._meta.lifecycle?.expiryTime;
  let t3;
  if ($[4] !== handleUserOpen || $[5] !== promoToolModuleData.announcementBar || $[6] !== t2) {
    t3 = <PromoAnnouncementBar content={promoToolModuleData.announcementBar} onCtaClick={handleUserOpen} expiryDate={t2} />;
    $[4] = handleUserOpen;
    $[5] = promoToolModuleData.announcementBar;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = showPopup ? "fixed" : "hidden";
  let t5;
  if ($[8] !== t4) {
    t5 = clsx("inset-0 h-screen w-screen bg-black/20 backdrop-blur-[1px]", t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== applyVoucher || $[13] !== handleClose || $[14] !== showPopup) {
    t7 = <PromoPopup open={showPopup} onClose={handleClose} applyVoucher={applyVoucher} nested={true} />;
    $[12] = applyVoucher;
    $[13] = handleClose;
    $[14] = showPopup;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t6 || $[18] !== t7) {
    t8 = <>{t3}{t6}{t7}</>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}